import { render, staticRenderFns } from "./Assemblies.vue?vue&type=template&id=796d6896&"
import script from "./Assemblies.vue?vue&type=script&lang=js&"
export * from "./Assemblies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports